import React, { memo, useCallback, useMemo } from 'react';

import { Box } from '@mui/material';
import _ from 'lodash';
import PropTypes from 'prop-types';

import ColumnDateFilterMenu from './ColumnDateFilterMenu';
import { EMPTY_FILTER_VALUES } from './ColumnFilterElement.constants';
import ColumnFilterMenu from './ColumnFilterMenu';
import ColumnSelectFilterMenu from './ColumnSelectFilterMenu';

const ColumnFilterElement = ({ filter, columnKey, columnFilters, onColumnFiltersChange }) => {
  const isSelectFilter = useMemo(() => _.isObject(filter) && !!filter.selectOptions, [filter]);
  const isDateFilter = useMemo(() => _.isObject(filter) && !!filter.isDateRange, [filter]);

  const handleContainerClick = useCallback(e => {
    e.stopPropagation();
  }, []);

  const renderFilterMenu = () => {
    if (isDateFilter) {
      return (
        <ColumnDateFilterMenu
          columnKey={columnKey}
          filterEnd={columnFilters?.[columnKey]?.end}
          filterStart={columnFilters?.[columnKey]?.start}
          onFilterChange={onColumnFiltersChange}
        />
      );
    }

    if (isSelectFilter) {
      return (
        <ColumnSelectFilterMenu
          columnKey={columnKey}
          filterType={filter.filterType}
          filterValues={columnFilters?.[columnKey]?.values || EMPTY_FILTER_VALUES}
          selectOptions={filter.selectOptions}
          onFilterChange={onColumnFiltersChange}
        />
      );
    }

    return (
      <ColumnFilterMenu
        columnKey={columnKey}
        filterMode={columnFilters?.[columnKey]?.mode}
        filterValue={columnFilters?.[columnKey]?.value}
        onFilterChange={onColumnFiltersChange}
      />
    );
  };

  return (
    <Box component="span" onClick={handleContainerClick}>
      {renderFilterMenu()}
    </Box>
  );
};

ColumnFilterElement.propTypes = {
  filter: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]).isRequired,
  columnKey: PropTypes.string.isRequired,
  onColumnFiltersChange: PropTypes.func.isRequired,
  columnFilters: PropTypes.object,
};

export default memo(ColumnFilterElement);
